"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("mktHistoryUtils", function ($translate) {
  return {
    /**
     * Génère un 'id' serializable pour la référence, pour permettre des comparaisons
     * @param reference
     */
    getReferenceId: function getReferenceId(reference) {
      if (reference == null) {
        return null;
      }
      var base = reference.type + "-";
      if (reference.type === "INDEX") {
        base += reference.indexId;
      } else if (reference.type === "CUSTOM_INDEXATION") {
        base += reference.indexationId;
      }
      return base;
    },
    isSameReference: function isSameReference(ref1, ref2) {
      // TODO : use getReferenceId instead
      if (ref1 == null || ref2 == null) {
        return false;
      } else if (ref1.type !== ref2.type) {
        return false;
      } else {
        if (ref1.type === "INDEX") {
          return ref1.indexId === ref2.indexId;
        } else if (ref1.type === "CUSTOM_INDEXATION") {
          return ref1.indexationId === ref2.indexationId;
        }
      }
    },
    /**
     * Vérifie la validité de structure du ValorisableReference donné :
     * Si de type INDEX, alors soit avoir un indexId,
     * Si de type CUSTOM_INDEXATION, alors doit avoir un attribute indexationId
     */
    isReferenceValid: function isReferenceValid(reference) {
      if (reference == null) {
        return false;
      }
      if (reference.type === "INDEX") {
        return reference.indexId != null;
      } else if (reference.type === "CUSTOM_INDEXATION") {
        return reference.indexationId != null;
      } else {
        return false;
      }
    },
    /**
     * Retourne le label à afficher sur l'axe de la courbe en fonction de l'indexType
     * @param indexType Valeur de l'enum IndexType.
     * @return {string} Le libellé à afficher.
     */
    getIndexTypeAxisLabel: function getIndexTypeAxisLabel(indexType) {
      switch (indexType) {
        case "TAUX":
          return $translate('marche.history.axisLabel.Taux');
        case "CHANGE":
          return $translate('marche.history.axisLabel.Cours');
        // yea, taux de change...
        case "INDICIEL":
          return $translate('marche.history.axisLabel.Valeur');
        default:
          return "";
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/mktHistoryUtils.js
// module id = 2758
// module chunks = 13